// Keep CMS schema records out of public pages, lists and feeds.
function isPlaceholder(entry) {
  if (!entry) return false
  const normalize = value => String(value || '').trim().toLowerCase()
  return normalize(entry.slug) === 'non-eliminare' ||
    normalize(entry.titolo || entry.label) === 'non eliminare'
}

module.exports = { isPlaceholder }
